module.exports = __webpack_public_path__ + "img/home.d4884ae1.png";